// Exports
export default {
	"container": "container_U8N7A",
	"textWrapper": "textWrapper_RYrO5",
	"badge": "badge_iL7ZW",
	"withDot": "withDot_gvg8Q",
	"mainText": "mainText_LwDa0",
	"Button": "Button_hGnJn",
	"isSidebarVisible": "isSidebarVisible_ZPcay",
	"collapsible": "collapsible_cPH5j",
	"default": "default_G3DXH",
	"huge": "huge_ZQU+o",
	"statusNotification": "statusNotification_HhpHi",
	"statusNotificationIconContainer": "statusNotificationIconContainer_7G-pu",
	"statusNotificationText": "statusNotificationText_m0nnF"
};
